<template>
  <div
    class="bg-white px-4 relative flex items-center w-full transition-all duration-300 ease-in-out shadow-sm"
  >
    <!-- Logo -->
    <div
      :class="heightClass"
      class="flex flex-col items-center justify-center w-32 py-4 flex-shrink-0 transition-all duration-300 ease-in-out"
    >
      <div
        class="bg-no-repeat bg-center bg-contain flex items-center justify-center flex-shrink-0 w-full h-full"
        :style="[{ backgroundImage: 'url(' + settings.logo + ')' }]"
      >
        <span class="hidden">{{ settings.profile_title }}</span>
      </div>
    </div>

    <div
      :style="{ width: 'calc(100vw - 21rem)' }"
      class="transition-all duration-300 ease-in-out relative"
    >
      <div
        :style="{ width: 'calc(100vw - 21rem)' }"
        :class="heightClass"
        class="w-full transition-all duration-300 ease-in-out bg-white"
      >
        <!-- Menu Content -->
        <div class="flex flex-col gap-4 h-full">
          <div class="w-full">
            <ul class="flex w-full items-center justify-center gap-16 pt-10">
              <li
                class="menu-item text-center px-2 pb-2 w-full cursor-pointer hover:text-primary flex-shrink-0 font-bold text-base flex items-center"
                :class="[
                  { active: 'Home' === activeMenuItem },
                  'Home' === activeMenuItem ? 'text-primary font-bold' : '',
                ]"
                @click="pushRoute('Home')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="w-4 h-4 mr-2"
                >
                  <path
                    fill-rule="evenodd"
                    d="M9.293 2.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 17 11h-1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6H3a1 1 0 0 1-.707-1.707l7-7Z"
                    clip-rule="evenodd"
                  />
                </svg>

                Home
              </li>

              <li
                class="menu-item text-center px-2 pb-2 w-full cursor-pointer hover:text-primary flex-shrink-0 font-bold text-base flex items-center relative group"
                :class="[
                  { active: activePostsItem },
                  activePostsItem ? 'text-primary font-bold' : '',
                ]"
                :style="{ marginRight: '-1.25rem' }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="w-4 h-4 mr-2"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10 2c-1.716 0-3.408.106-5.07.31C3.806 2.45 3 3.414 3 4.517V17.25a.75.75 0 0 0 1.075.676L10 15.082l5.925 2.844A.75.75 0 0 0 17 17.25V4.517c0-1.103-.806-2.068-1.93-2.207A41.403 41.403 0 0 0 10 2Z"
                    clip-rule="evenodd"
                  />
                </svg>

                Posts

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="w-4 h-4 ml-2"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                    clip-rule="evenodd"
                  />
                </svg>

                <div
                  class="p-4 w-[110px] border border-truegray-300 absolute top-full left-0 flex flex-col bg-white z-50 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-all"
                >
                  <!-- v-if="customisation?.contentPostTypes.includes(1)" if logic should be tied to settings instead -->
                  <!--
                    :class="
                    [2, 3].some((value) =>
                    customisation.contentPostTypes.includes(value),
                    )
                    ? 'border-b border-truegray-100 pb-2 mb-2'
                    : ''
                    " 
                  -->
                  <p
                    class="font-semibold text-sm text-black hover:text-primary cursor-pointer border-b border-truegray-100 pb-2 mb-2"
                    :class="
                      activePostsItem === 'news' ? 'text-primary font-bold' : ''
                    "
                    @click="pushToPosts('news')"
                  >
                    News
                  </p>
                  <p
                    v-if="settings.total_events > 0"
                    :class="[
                      settings.total_jobs > 0
                        ? 'border-b border-truegray-100 pb-2 mb-2'
                        : '',
                      activePostsItem === 'events'
                        ? 'text-primary font-bold'
                        : '',
                    ]"
                    class="font-semibold text-sm text-black hover:text-primary m-0 cursor-pointer"
                    @click="pushToPosts('events')"
                  >
                    Events
                  </p>
                  <p
                    v-if="settings.total_jobs > 0"
                    :class="
                      activePostsItem === 'jobs' ? 'text-primary font-bold' : ''
                    "
                    class="font-semibold text-sm text-black hover:text-primary m-0 cursor-pointer"
                    @click="pushToPosts('jobs')"
                  >
                    Jobs
                  </p>
                </div>
              </li>

              <li
                v-if="isConnectionsFeatureEnabled"
                class="menu-item text-center px-2 pb-2 w-full cursor-pointer hover:text-primary flex-shrink-0 font-bold text-base flex items-center"
                :class="[
                  { active: 'Connections' === activeMenuItem },
                  'Connections' === activeMenuItem
                    ? 'text-primary font-bold'
                    : '',
                ]"
                @click="pushRoute('PublicConnections')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  class="w-5 h-5 mr-2"
                >
                  <path
                    d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z"
                  />
                </svg>

                Connections
              </li>
            </ul>
          </div>
          <div class="w-full overflow-visible flex relative justify-center">
            <!-- Scroll button -->
            <div class="flex flex-col ml-2 items-center">
              <div
                v-if="isOverflowing && !smartMenuActive"
                :class="scrolledToLeft ? 'opacity-0' : ''"
                class="flex flex-col justify-center items-center cursor-pointer text-white hover:text-primary h-4 w-4 border-2 border-primary rounded-full bg-primary hover:bg-white transition-all duration-300 ease-in-out"
                @click="scroll('left')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>

            <!-- GUEST MENU -->
            <div
              id="tenantMenu"
              :style="{ maxWidth: 'calc(100vw - 26rem)' }"
              class="overflow-hidden transition-all duration-300 flex items-center px-2 w-full h-full z-20"
            >
              <ul
                id="tenantMenuContent"
                class="overflow-x-auto no-scrollbar relative transition duration-150 ease-in-out flex items-center space-x-4 w-full h-full"
                :class="isOverflowing ? 'justify-start' : 'justify-center'"
              >
                <!-- DYNAMIC PAGES -->
                <li
                  v-for="(parent, i) in filteredMenu"
                  :key="i"
                  :ref="'menu-item' + i"
                  :class="[
                    {
                      'text-primary font-bold':
                        parent.id == activeMenuItem ||
                        parent.id === activeMenuParent,

                      'ddActive': parent.id === activeDropdown,
                    },
                  ]"
                  class="menu-item font-semibold text-center flex-shrink-0 w-full h-full flex flex-wrap items-center group overflow-visible relative"
                >
                  <!-- Dropdown Parent -->
                  <div
                    v-if="parent.children.length >= 1"
                    :id="'parent-' + parent.id"
                    class="w-full h-full cursor-pointer hover:text-primary flex-shrink-0 px-2 pb-4"
                    @mouseover="handleDDHover(parent)"
                    @mouseleave="handleMouseLeaveParent(parent)"
                  >
                    <div
                      class="w-full flex items-center justify-center"
                      :class="[
                        ,
                        activeDropdown === parent.id ? 'text-primary' : '',
                        ,
                      ]"
                    >
                      <span class="mr-2 clamp-2 font-semibold text-xs">{{
                        parent.title
                      }}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="lg:ml-auto h-4 w-4 flex-shrink-0"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>

                  <!-- Standard pages -->
                  <div
                    v-else
                    :class="[
                      parent.page_type === 2
                        ? 'group relative cursor-not-allowed'
                        : 'cursor-pointer',
                    ]"
                    class="w-full flex items-center space-x-1 justify-center hover:text-primary px-2 pb-4"
                    @click="pushToPageRoute(parent)"
                  >
                    <svg
                      v-if="parent.page_type === 1"
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3 w-3 opacity-50"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                    <!-- If parent is a label but has no children, alert the admin about the mistake -->
                    <svg
                      v-if="parent.page_type === 2 && user"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="h-3 w-3 opacity-50"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                      />
                    </svg>
                    <div
                      v-if="parent.page_type === 2 && user"
                      :class="infoClass"
                    >
                      You have created a label with no dropdown items inside.
                    </div>
                    <span class="font-semibold text-xs">{{
                      parent.title
                    }}</span>
                  </div>
                </li>
              </ul>
            </div>

            <!-- Scroll button -->
            <div class="flex flex-col mr-2 items-center">
              <div
                v-if="isOverflowing && !smartMenuActive"
                :class="scrolledToRight ? 'opacity-0' : ''"
                class="flex flex-col justify-center items-center cursor-pointer text-white hover:text-primary h-4 w-4 border-2 border-primary rounded-full bg-primary hover:bg-white transition-all duration-300 ease-in-out"
                @click="scroll('right')"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-48 h-full flex items-center justify-center">
      <button
        type="button"
        class="btn btn-primary mb-0 mr-4"
        @click="scrollToContact"
      >
        Contact
      </button>
    </div>

    <!-- Smart menu trigger - this is duplicated into the layout3 home template to handle scroll bar bullshit - turn off on home page -->
    <div
      :class="
        scrolledToTop && activeMenuItem !== 'Home'
          ? 'opacity-100 pointer-events-auto'
          : 'opacity-0 pointer-events-none'
      "
      class="transition-all hidden lg:block absolute top-full text-xs right-0 rounded-bl-xl overflow-hidden mr-8"
    >
      <div class="flex pr-px">
        <div
          v-if="isOverflowing"
          class="bg-black hover:bg-primary text-white cursor-pointer z-20 rounded-bl-xl overflow-hidden flex items-center justify-center gap-2 py-2 px-8 relative left-2 z-10"
          @click="showFullMenu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-4 h-4"
          >
            <path
              fill-rule="evenodd"
              d="M3 9a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9Zm0 6.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
              clip-rule="evenodd"
            />
          </svg>

          See full menu
        </div>
        <div
          v-else
          class="cw-gradient text-white z-20 rounded-bl-xl overflow-hidden flex items-center justify-center gap-2 py-2 px-8 relative left-2 z-10"
        >
          <div>
            <img
              src="/img/logo-cw.png"
              alt="CareerWise logo"
              class="w-5 mr-2"
            />
          </div>
          <div class="flex flex-col cursor-pointer" @click="openMarketingSite">
            <h5 class="text-[8px] text-white font-thin mb-0">Powered by</h5>
            <h5 class="text-xs font-bold text-white mb-0">CareerWise</h5>
          </div>
        </div>
        <div
          v-if="!user"
          :class="[
            isOverflowing ? 'bg-truegray-700' : 'bg-black',
            scrolledToTop && activeMenuItem === 'Home'
              ? 'rounded-tr-xl'
              : 'rounded-br-xl',
          ]"
          class="text-white rounded-bl-xl overflow-hidden flex items-center justify-center gap-2 py-2 px-8 cursor-pointer z-20"
          @click="showLoginModal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-4 h-4"
          >
            <path
              fill-rule="evenodd"
              d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
              clip-rule="evenodd"
            />
          </svg>

          Login
        </div>
        <div
          v-if="user"
          :class="[
            isOverflowing
              ? 'bg-truegray-700 hover:bg-truegray-500'
              : 'bg-black hover:bg-truegray-700',
            scrolledToTop && activeMenuItem === 'Home'
              ? 'rounded-tr-xl'
              : 'rounded-br-xl',
          ]"
          class="transition-all text-white rounded-bl-xl overflow-hidden flex items-center justify-center gap-2 py-2 px-8 cursor-pointer z-20"
          @click="openAdminMenu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-4 h-4"
          >
            <path
              d="M6 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 1 1 1.5 0v7.5A.75.75 0 0 1 6 12ZM18 12a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 18 12ZM6.75 20.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM18.75 18.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0ZM12.75 5.25v-1.5a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0ZM12 21a.75.75 0 0 1-.75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A.75.75 0 0 1 12 21ZM3.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0ZM12 11.25a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5ZM15.75 15a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 0 0-4.5 0Z"
            />
          </svg>
          Admin Panel
        </div>
      </div>
    </div>

    <!-- dropdown container -->
    <!-- using a slight hack to pull the dropdown container 0.5rem up and then adding 0.5rem of padding at the top of the v-for div for alignment -->
    <!-- so that the mouse stays within the confines of the div group for all of the ddHover methods rather than change the stupid html -->
    <div
      :class="[activeDropdown === null ? 'pointer-events-none' : '']"
      class="absolute left-0 top-[7rem] w-full h-full z-10"
    >
      <div
        v-for="(parent, i) in filteredMenu"
        :id="'dd-' + parent.id"
        :key="i"
        :class="[
          activeDropdown === parent.id ? '' : 'opacity-0 pointer-events-none',
        ]"
        class="absolute transition-opacity duration-300 pt-4"
        :style="[
          { width: '300px' },
          { maxWidth: '300px' },
          { minWidth: ddWidth },
          { left: ddPosX + 'px' },
        ]"
        @mouseleave="closeDD"
      >
        <div
          v-if="parent.children.length >= 1"
          class="w-full cursor-pointer flex-shrink-0 px-2"
        >
          <!-- Dropdown Children -->
          <div
            class="sub-menu bg-primary w-full px-2 transition-all duration-300 shadow text-white"
          >
            <ul class="w-full space-y-4 py-6">
              <li
                v-if="parent.page_type !== 2 && !parent.static"
                class="px-4 transition-all duration-300 w-full flex items-center space-x-1 text-left cursor-pointer hover:font-bold text-xs"
                :class="{
                  'font-bold': activeMenuItem === parent.id,
                }"
                @click="pushToPageRoute(parent)"
              >
                <span>{{ parent.title }}</span>
                <svg
                  v-if="parent.page_type === 1"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3 opacity-50"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
              </li>
              <li
                v-for="(child, j) in parent.children"
                :key="j"
                class="px-4 transition-all duration-300 w-full flex items-center space-x-1 text-left cursor-pointer hover:font-bold text-xs"
                :class="{
                  'font-bold':
                    activeMenuItem === child.id ||
                    child.title.toLowerCase() ==
                      (typeof activePostsItem === 'string'
                        ? activePostsItem.toLowerCase()
                        : ''),
                }"
                @click="pushToPageRoute(child)"
              >
                <span class="clamp-3">{{ child.title }}</span>
                <svg
                  v-if="child.page_type === 1"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3 opacity-50"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                  />
                </svg>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { useStore } from '../../../../../../js/store/index.js'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import {
  validateURL,
  validateURLProtocol,
  updateURLWithProtocol,
  scrollToElement,
} from '../../../../../../js/util/helper.js'

export default defineComponent({
  name: 'Layout2Menu',
  components: {},

  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const infoClass =
      'absolute left-12 label-error w-64 z-50 border border-truegray-300 rounded p-4 opacity-0 transition-all duration-300 transform pointer-events-none shadow group-hover:opacity-100 bg-white'
    const heightClass = 'h-32'
    const smartMenuActive = ref(false)

    const settings = computed(() => store.getters['shared/getSettings'])
    const customisation = computed(
      () => store.getters['careerwise/getCustomisation'],
    )
    const user = computed(() => store.getters['shared/getUser'])
    const menu = computed(() => store.getters['shared/getMenu'])
    const isConnectionsFeatureEnabled = computed(
      () => store.getters['careerwise/isConnectionsFeatureEnabled'],
    )

    const filteredMenu = computed(() => {
      let menuClone = menu.value
        .filter((item) => item.status === 1)
        .map((item) => ({
          ...item,
          children: item.children.filter((child) => child.status === 1),
        }))

      return menuClone
    })

    // #region - Window watchers
    const scrolledToTop = ref(true)

    const checkWindowPosition = () => {
      window.onscroll = () => {
        if (window.scrollY <= 10) {
          scrolledToTop.value = true
        } else {
          scrolledToTop.value = false
        }
      }
    }
    // #endregion

    // #region - Menu overflow handling
    const isOverflowing = ref(false)
    const scrolledToLeft = ref(true)
    const scrolledToRight = ref(false)

    const checkOverflow = () => {
      let overflowMenu = document.getElementById('tenantMenu')
      let content = document.getElementById('tenantMenuContent')

      if (overflowMenu) {
        let overflowing = overflowMenu.scrollWidth < content.scrollWidth
        isOverflowing.value = overflowing
      }
    }

    const scroll = (direction) => {
      let overflowMenu = document.getElementById('tenantMenu')
      let content = document.getElementById('tenantMenuContent')

      let scrollWidth = content.scrollWidth
      let menuWidth = overflowMenu.clientWidth
      // let currentScroll = overflowMenu.scrollY + overflowMenu.innerHeight;

      if (direction === 'left') {
        content.scrollBy(-250, 0)
      } else {
        content.scrollBy(250, 0)
      }

      // Are we scrolled to left or right? Hide arrows. Set timeout to allow smooth scroll to play out
      setTimeout(() => {
        let scrollLeft = content.scrollLeft
        if (scrollLeft <= 3) {
          scrolledToLeft.value = true
        } else {
          scrolledToLeft.value = false
        }
        if (scrollLeft + menuWidth >= scrollWidth) {
          scrolledToRight.value = true
        } else {
          scrolledToRight.value = false
        }
      }, 300)
    }
    // #endregion

    // #region - Menu dropdown handling
    const ddPosX = ref(0)
    const ddWidth = ref(0)
    const activeDropdown = ref(null)

    const handleDDHover = (parent) => {
      let parentEl = document.getElementById('parent-' + parent.id)
      let dd = document.getElementById('dd-' + parent.id)
      let parent_position = parentEl.getBoundingClientRect()
      let position = parent_position.x - 15
      if (dd && parent) {
        ddPosX.value = position
        ddWidth.value = parent_position.width
        activeDropdown.value = parent.id
      }
    }

    const handleMouseLeaveParent = (parent) => {
      let element = document.getElementById('dd-' + parent.id)
      if (element.parentNode.querySelector(':hover') === element) {
        //Mouse is inside element
      } else {
        closeDD()
      }
    }

    const closeDD = () => {
      activeDropdown.value = null
    }
    // #endregion

    // #region - Route handling
    const pushToPosts = (type) => {
      if (route.name === 'Posts') {
        const currentRoute = route
        const desiredPath = '/posts'
        const desiredType = type
        const currentType = currentRoute.query.category

        if (currentRoute.path !== desiredPath || currentType !== desiredType) {
          const updatedQuery = { ...currentRoute.query, category: desiredType }
          router.replace({ path: currentRoute.path, query: updatedQuery })
          activePostsItem.value = type
        }
      } else {
        router.push({
          path: '/posts?category=' + type,
          params: { type: type },
        })
      }
      EventBus.$emit('closeResourceModals')
      EventBus.$emit('posts_params_changed')
      EventBus.$emit('modal_state_changing', false)
    }

    const pushRoute = (route) => {
      if (route === 'Posts' && router.currentRoute.name === route) {
        EventBus.$emit('NonManagerRouteClicked')
        EventBus.$emit('showSmartMenu', false)
        EventBus.$emit('reload_posts_to_published')
      }
      if (router.currentRoute.name !== route) {
        EventBus.$emit('NonManagerRouteClicked')
        EventBus.$emit('showSmartMenu', false)
        router.push({ name: route })
      }
      EventBus.$emit('closeResourceModals')
      EventBus.$emit('closeMobileMenu')
      EventBus.$emit('modal_state_changing', false)
    }

    const pushToPageRoute = (item) => {
      if (item.page_type === 2) {
        return
      }
      let url = item.external_link
      if (item.external_link && validateURL(url)) {
        if (!validateURLProtocol(url)) {
          url = updateURLWithProtocol(url)
        }
        window.open(url, '_blank')
        return
      }
      let id = item.id
      activeDropdown.value = null
      EventBus.$emit('NonManagerRouteClicked')
      if (item.postsPage) {
        pushToPosts(item.postsRoute)
      } else if (item.route) {
        router.push({ path: '/' + item.route })
      } else {
        router.push({ path: '/page/' + id })
      }
      EventBus.$emit('closeResourceModals')
      EventBus.$emit('showSmartMenu', false)
      EventBus.$emit('closeMobileMenu')
      EventBus.$emit('modal_state_changing', false)
    }
    // #endregion

    // #region - Active menu item handling
    const activeMenuItem = ref('Home')
    const activeDropdownItem = ref(null)
    const activePostsItem = ref(null)
    const activeMenuParent = ref(null)

    watch(
      () => route.path,
      (to) => {
        if (to === '/') {
          activeMenuItem.value = 'Home'
          activePostsItem.value = null
        } else if (to.includes('/page/')) {
          const idString = to.split('/').pop()
          const id = Number(idString)
          activeMenuItem.value = id
          activePostsItem.value = null

          // Find the page with the id of activeMenuItem
          const page =
            filteredMenu.value.find((parent) => parent.id === id) ||
            filteredMenu.value
              .flatMap((parent) => parent.children)
              .find((child) => child.id === id)

          // Set activeMenuParent to parent_id if it exists
          if (page && page.parent_id) {
            activeMenuParent.value = Number(page.parent_id)
          } else {
            activeMenuParent.value = null
          }
        } else if (to.includes('/posts')) {
          activeMenuItem.value = 0
          if (route.query.category) {
            activePostsItem.value = route.query.category
          }
        } else if (to.includes('/connections')) {
          activeMenuItem.value = 'Connections'
          activePostsItem.value = null
        } else {
          activeMenuItem.value = null
          activePostsItem.value = null
        }
      },
      { immediate: true },
    )

    // #endregion

    // #region - Smart menu handling
    const scrollToContact = () => {
      // Check if we are on the home page
      if (route.name !== 'Home') {
        // If not, navigate to the home page
        router.push({ path: '/' }).then(() => {
          // Wait for the navigation to complete before calling helper function
          // also allow some time for the posts to come back to stop dom shift
          // @todo do this better or adjust value once prod speeds can be tested
          setTimeout(() => {
            scrollToElement('contactForm')
          }, 700)
        })
      } else {
        // If we are already on the home page, just call helper function
        scrollToElement('contactForm')
      }
    }

    const showFullMenu = () => {
      EventBus.$emit('showSmartMenu', true)
    }

    const openMarketingSite = () => {
      window.open('https://careerwise.school', '_blank')
    }

    const showSubscribeModal = () => {
      EventBus.$emit('showModal', 'subscribe')
    }

    const showLoginModal = () => {
      EventBus.$emit('showModal', 'login')
    }

    const openAdminMenu = () => {
      EventBus.$emit('showSmartMenu', true)
      EventBus.$emit('openAdminMenu')
    }

    const triggerLogOut = () => {
      EventBus.$emit('showModal', 'logout')
    }
    // #endregion

    onMounted(() => {
      setTimeout(() => {
        checkOverflow()
      }, 10)

      EventBus.$on('smartMenuStateChanged', (active) => {
        smartMenuActive.value = active
      })

      checkWindowPosition()
    })

    return {
      filteredMenu,
      settings,
      customisation,
      user,
      menu,
      isConnectionsFeatureEnabled,

      infoClass,
      heightClass,

      isOverflowing,
      checkWindowPosition,
      scroll,
      scrolledToTop,
      scrolledToLeft,
      scrolledToRight,

      showFullMenu,
      openMarketingSite,
      showSubscribeModal,
      showLoginModal,
      openAdminMenu,
      smartMenuActive,
      scrollToContact,
      triggerLogOut,

      pushToPosts,
      pushRoute,
      pushToPageRoute,

      activeDropdown,
      activeMenuItem,
      activeDropdownItem,
      activeMenuParent,
      activePostsItem,
      ddPosX,
      ddWidth,
      handleDDHover,
      handleMouseLeaveParent,
      closeDD,
    }
  },
})
</script>

<style scoped>
.scroll-text {
  font-size: 8px;
}

.menu-item {
  width: max-content;
  /* max-width: 175px; */
}

.clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.label-error {
  top: 50%;
  transform: translateY(-50%);
}

#tenantMenu,
#tenantMenuContent {
  scroll-behavior: smooth;
}
</style>
